import React, { useContext } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { AuthContext } from './context/auth.context';
import Layout from './components/Layout';

const PrivateRoute = ({ children, ...rest }) => {
	const currentUser = useContext(AuthContext);

	return !!currentUser ? (
		<Route {...rest}>
			<Layout>{children}</Layout>
		</Route>
	) : (
		<Redirect to={'/login'} />
	);
};

export default PrivateRoute;
